import React from 'react'

const Divider = React.forwardRef(
  (
    {
      children,
      orientation = 'horizontal',
      variant = 'fullWidth',
      flexItem = false,
      className = '',
      sx = {},
      ...props
    },
    ref
  ) => {
    const getDividerStyles = () => {
      const styles = {
        border: 'none',
        margin: 0,
        flexShrink: 0
      }

      if (orientation === 'horizontal') {
        styles.borderTop = '1px solid'
        styles.borderTopColor = 'currentColor'
        styles.width = variant === 'fullWidth' ? '100%' : 'auto'
        if (flexItem) {
          styles.alignSelf = 'stretch'
        }
      } else {
        styles.borderLeft = '1px solid'
        styles.borderLeftColor = 'currentColor'
        styles.height = variant === 'fullWidth' ? '100%' : 'auto'
        if (flexItem) {
          styles.alignSelf = 'stretch'
        }
      }

      return styles
    }

    const dividerStyles = getDividerStyles()

    if (children) {
      return (
        <div
          ref={ref}
          className={className}
          style={{ ...dividerStyles, ...sx }}
          {...props}
        >
          <span style={{ padding: '0 16px' }}>{children}</span>
        </div>
      )
    }

    return (
      <hr
        ref={ref}
        className={className}
        style={{ ...dividerStyles, ...sx }}
        {...props}
      />
    )
  }
)

Divider.displayName = 'Divider'

export default Divider
